/* prettier-ignore */

import { DatePipe } from '@angular/common';
import { Component, inject, input, Input, InputSignal, ViewEncapsulation } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ToolsService } from 'src/app/services/tools.service';

@Component({
    standalone: true,
    imports: [
        TranslateModule,
        DatePipe
    ],
    templateUrl: './modal.component.html',
    styleUrls: ['./modal.component.scss'],
    encapsulation: ViewEncapsulation.None,
})

export class ModalOfferComponent  {
    public offer: InputSignal<any> = input.required<any>();
    public translate = inject(TranslateService);
    public tools = inject(ToolsService);
    private modalController = inject(ModalController);

    dismissModal(){
        this.modalController.dismiss().catch(e => {
            console.warn("No modal found on dismiss")
        });
    }

    goToURL(url){
        window.open(url, '_blank');
    }

}